// import Logo from './atxSantasLogo';
import React, { useEffect, useState } from 'react';
import {
  Link
} from 'react-router-dom';
import { HeaderWrap, NavBar } from '../css/_styledComponents';
import LensFlare from './LensFlare';

import blackHawksLogo from '../images/BHLogo.png';
import spSaints from '../images/spSaints.png';

export default function Header () {
  const [isStuck, setIsStuck] = useState('relative');

  useEffect(() => {
    setIsStuck(false);
    window.addEventListener('scroll', stickNavbar);
    return () => {
      window.removeEventListener('scroll', stickNavbar);
    };
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > 140 ? setIsStuck(true) : setIsStuck(false);
    }
  };

  return (
    <HeaderWrap>
      {/* <LensFlare /> */}
      <Link to="/home">
        <img
          src={blackHawksLogo}
          className="hawksLogo"
        />
        <img
          src={spSaints}
          className="saintsLogo"
        />
        <div className="headerTitle">
          <span>
            Virgil Johnson
          </span>
        </div>
        <div className="headerSubtitle">
          US Hockey Hall of Fame Defenseman
        </div>
      </Link>
      <NavBar isStuck={isStuck}>
        <Link to="/">
          Home
        </Link>
        <Link to="/career">
          Career
          <span> &amp; Awards</span>
        </Link>
        <Link to="/stats">
          Statistics
        </Link>
        <Link to="/personalhistory">
          <span>Personal </span>
          History
        </Link>
      </NavBar>
    </HeaderWrap>
  );
}
